import "babel-polyfill";
import Vue from 'vue';
import Couponplatz from './couponplatz.vue';

new Vue(Object.assign({
	el: '#couponplatz',
	// Vuejs webpack simple template suggests using a render method here which we don't need
	// render: createElement => createElement(Couponplatz)
}, Couponplatz));



// WEBPACK FOOTER //
// ./src/main.js